import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import reportWebVitals from './reportWebVitals';

import './index.css';
import "@fontsource/metropolis";
import DashboardPageLayout from './layouts/DashboardPageLayout';
import LoginPage from './LoginPage';
import DefaultLandingPage from './pages/DefaultLandingPage';
import DeviceDetailsPage from './pages/DeviceDetailsPage';
import { tenantConfig } from "./whitelabels/tenantsConfig";
import { getMasterTenant } from "./whitelabels/theme.js";


const ProtectedRoute = ({ children, allowedRoles=[] }) => {
  const token = sessionStorage.getItem('jwtToken');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  try {
    const decoded = jwtDecode(token);

    // If expire, force it back to the login page
    if (decoded.exp && decoded.exp * 1000 < Date.now()) {
      const tenantPath = sessionStorage.getItem("tenantPath");
      sessionStorage.removeItem("jwtToken");
      sessionStorage.removeItem('tenantPath');

      // rediect it to the longTenantPath (master Tenant)
      const masterTenant = getMasterTenant(tenantPath);
      return <Navigate to={`/login?tenant=${masterTenant}`} replace />;
    }

    // Get the login user roles there.
    const userRole = decoded.role;

    if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
      return <Navigate to="/login" replace />;
    }
    return children;
  } catch (error) {
    // Invalid/malformed JWT
    sessionStorage.removeItem("jwtToken");
    return <Navigate to="/login" replace />;
  }
};

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          {/* Public route for different tenant */}
          <Route path="/login" element={<LoginPage />} />

          {/* Parse the tenant out from the tenantConfig and redirect them */}
          {Object.keys(tenantConfig).map((tenant) => (
            <Route
              key={tenant}
              path={`/${tenant}`}
              element={<Navigate to={`/login?tenant=${tenant}`} replace />}
            />
          ))}

          <Route 
            path="/" 
            element={
              <ProtectedRoute allowedRoles={["god", "admin", "subAdmin"]}>
                {/* Dashboard Route for role God, admin and subAdmin only */}
                <DashboardPageLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DefaultLandingPage />}/>
          </Route>
          {/* Every user which logined in */}
          <Route 
            path="/devices/:deviceId" 
            element={
              <ProtectedRoute allowedRoles={["god", "admin", "subAdmin", "viewer"]}>
                {/* Device Detial Route for all known role */}
                <DashboardPageLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DeviceDetailsPage/>}/>
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
